import React, { useEffect, useState } from 'react'
import { Services } from '@/services/services'
import { CurrentSession } from '@/services/repository/session'
import { Translates } from '@/services/repository/i18n'
import { Roles, isAdminRole } from '@/services/repository/users'

export const MachineUDTNumber = ({ machineId, value, services, session, translates, onSaved }: {
  machineId: string
  value?: string
  services: Services
  session?: CurrentSession | null
  translates: Translates
  onSaved: () => void
}) => {
  const [number, setNumber] = useState(value || '')
  const [saving, setSaving] = useState(false)
  const [error, setError] = useState(false)
  useEffect(() => { setNumber(value || ''); setError(false) }, [machineId, value])
  const role = session?.user.role
  const canEdit = isAdminRole(role) || [Roles.CompanyAdmin, Roles.CompanyManager, Roles.Serviceman].includes(role as Roles)
  const title = translates.for('forms.machine.fields.udtNumber.title')

  const save = async (event: React.FormEvent) => {
    event.preventDefault()
    setSaving(true)
    setError(false)
    try {
      const response = await services.session.fetchWithToken(`/api/communal/machines/byid/${machineId}/udt-number`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ udtNumber: number }),
      })
      if (!response.ok) throw new Error('Save failed')
      onSaved()
    } catch {
      setError(true)
    } finally {
      setSaving(false)
    }
  }

  return <div className='grid-item'>
    {canEdit ? <form onSubmit={save}>
      <label className='label' htmlFor='machine-udt-number'>{title}</label>
      <input id='machine-udt-number' type='text' value={number} disabled={saving}
        placeholder={translates.for('forms.machine.fields.udtNumber.placeholder')}
        onChange={event => setNumber(event.target.value)} />
      <button className='main-btn' type='submit' disabled={saving || number === (value || '')}>
        {translates.for('forms.machine.submit')}
      </button>
      {error && <div role='alert'>{translates.for('forms.machine.fields.udtNumber.saveError')}</div>}
    </form> : <><div className='label'>{title}</div><div className='value'>{value || '-'}</div></>}
  </div>
}
